"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _CatalogueCategoryCarousel = _interopRequireDefault(require("../../../components/CatalogueCategoryCarousel"));

var _HomePageBlock = _interopRequireDefault(require("./HomePageBlock"));

//
var useStyles = (0, _makeStyles.default)(function () {
  return (
    /* theme */
    {
      root: {},
      title: {},
      list: {}
    }
  );
}, {
  name: 'SxHomePageCatalogueFavorite'
});

function HomePageCatalogueFavorite(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      favoriteCategories = _ref.favoriteCategories,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "favoriteCategories", "size"]);
  var classes = useStyles({
    className: className,
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return favoriteCategories && /*#__PURE__*/_react.default.createElement(_HomePageBlock.default, (0, _extends2.default)({}, rest, {
    className: classes.root
  }), /*#__PURE__*/_react.default.createElement(_CatalogueCategoryCarousel.default, {
    title: t('homepage/catalogFavorite'),
    categories: favoriteCategories
  }));
}

process.env.NODE_ENV !== "production" ? HomePageCatalogueFavorite.propTypes = {
  classes: _propTypes.default.shape({
    list: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  favoriteCategories: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  size: _propTypes.default.oneOf(['mini', 'small', 'normal', 'big'])
} : void 0;
HomePageCatalogueFavorite.defaultProps = {
  classes: undefined,
  className: undefined,
  size: undefined
};
var _default = HomePageCatalogueFavorite;
exports.default = _default;